"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
require("./checkbox.css");
;
/**
 * Main component.
 * @name Checkbox
 * @param {CheckboxProps}
 * @returns {<Checkbox />}
*/
const Checkbox = ({ checked = false, onChange, name, id }) => {
    return (react_1.default.createElement("input", { type: "checkbox", name: name, id: id, checked: checked, onChange: onChange, className: "checkbox" }));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=checkbox.js.map